export default __webpack_public_path__ + "static/media/arrow_down.d8d6bca1.svg";